import { render, staticRenderFns } from "./staffs.vue?vue&type=template&id=c8c7afa8&scoped=true&"
import script from "./staffs.vue?vue&type=script&lang=js&"
export * from "./staffs.vue?vue&type=script&lang=js&"
import style0 from "./staffs.vue?vue&type=style&index=0&id=c8c7afa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c7afa8",
  null
  
)

export default component.exports